module.exports = [{
      plugin: require('/var/www/gatsby-real-estate/node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"tomato","showSpinner":true},
    },{
      plugin: require('/var/www/gatsby-real-estate/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"google":{"families":["Montserrat:400,900:latin-ext,vietnamese","Roboto Condensed:400,700:latin-ext,vietnamese"]}},
    },{
      plugin: require('/var/www/gatsby-real-estate/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/var/www/gatsby-real-estate/packages/conghoagarden.com.vn/src/layouts/index.tsx"},
    },{
      plugin: require('/var/www/gatsby-real-estate/node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://conghoagarden.com.vn"},
    },{
      plugin: require('/var/www/gatsby-real-estate/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
